import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { Dispatch, SetStateAction } from 'react';

export interface CreateNewSelectOptionsProps {
  handleClose: () => void;
  onChange: any; //TODO
  data: any;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}
export function CreateNewSelectOptions(props: CreateNewSelectOptionsProps) {
  const { onChange, data } = props;
  const options = [
    {
      title: 'Sealing',
      description: 'Create new sealing registration',
      action: () => {
        onChange(-1, { ...(data || {}), option: 'sealing' });
      },
    },
    {
      title: 'Service plan',
      description: 'Create new service plan registration',
      action: () => {
        onChange(0, { ...(data || {}), option: 'service-plan' });
      },
    },
  ];
  return (
    <div className="pt-4">
      <div className="flex flex-col gap-2 p-4 pt-0">
        {options.map((option, index) => (
          <div
            key={index + '==min-option'}
            className="hover:bg-primary-100 hover:border-primary-400 ring:1 ring-primary-400 flex cursor-pointer items-center rounded-lg border border-gray-200 bg-gray-50 p-4"
            onClick={option.action}
          >
            <div className="flex flex-col">
              <div className="text-primary-800 font-nunito text-lg font-bold">
                {option.title}
              </div>
              <div className="text-small font-nunito text-gray-400">
                {option.description}
              </div>
            </div>
            <ArrowRightIcon className="text-primary-800 ml-auto h-6 w-6" />
          </div>
        ))}
      </div>
    </div>
  );
}
